import { PunctuationClass } from "./wordUnit";

/** where to expect a particular punctuation mark */
export enum PunctuationWhere {
  WordStart,
  WordEnd,
  WordBoth,   // can be at start or end of word
  Anywhere,   // needs special handling because it might not have whitespace around it
}

/** how to interpret various punctuation symbols */
export const punctuationMap: Record<string, [PunctuationClass, PunctuationWhere]> = {
  ",": [PunctuationClass.Pause, PunctuationWhere.WordEnd],
  "(": [PunctuationClass.Pause, PunctuationWhere.WordStart],
  ")": [PunctuationClass.Pause, PunctuationWhere.WordEnd],
  "[": [PunctuationClass.Pause, PunctuationWhere.WordStart],
  "]": [PunctuationClass.Pause, PunctuationWhere.WordEnd],
  "{": [PunctuationClass.Pause, PunctuationWhere.WordStart],
  "}": [PunctuationClass.Pause, PunctuationWhere.WordEnd],

  "…": [PunctuationClass.MediumPause, PunctuationWhere.WordEnd],
  ":": [PunctuationClass.MediumPause, PunctuationWhere.WordEnd],
  ";": [PunctuationClass.MediumPause, PunctuationWhere.WordEnd],

  ".": [PunctuationClass.Stop, PunctuationWhere.WordEnd],
  "?": [PunctuationClass.Stop, PunctuationWhere.WordEnd],
  "!": [PunctuationClass.Stop, PunctuationWhere.WordEnd],

  "'": [PunctuationClass.StartQuote, PunctuationWhere.WordBoth],
  '"': [PunctuationClass.StartQuote, PunctuationWhere.WordBoth],
  "“": [PunctuationClass.StartQuote, PunctuationWhere.WordStart],
  "”": [PunctuationClass.EndQuote, PunctuationWhere.WordEnd],
  "‘": [PunctuationClass.StartQuote, PunctuationWhere.WordStart],
  "’": [PunctuationClass.EndQuote, PunctuationWhere.WordEnd],

  "-": [PunctuationClass.Pause, PunctuationWhere.Anywhere], // ASCII
  "‐": [PunctuationClass.Pause, PunctuationWhere.Anywhere], // \U2010 unambiguous hyphen
  "‑": [PunctuationClass.Pause, PunctuationWhere.Anywhere], // \U2011 non-breaking hyphen
  "–": [PunctuationClass.Pause, PunctuationWhere.Anywhere], // \U2013 endash 
  "—": [PunctuationClass.Pause, PunctuationWhere.Anywhere], // \U2014 emdash
  "―": [PunctuationClass.Pause, PunctuationWhere.Anywhere], // \U2015 horizontal bar
  "\n": [PunctuationClass.EndParagraph, PunctuationWhere.Anywhere],
}
